
	import { defineComponent, getCurrentInstance, ref, onMounted } from 'vue'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { getDraftList, addDraftToTemp } from './request'
	import { message } from 'ant-design-vue'

	const columns = [
		{
			title: '创建时间',
			dataIndex: 'createTime',
			key: 'createTime'
		},
		{
			title: '版本号',
			dataIndex: 'version',
			key: 'version'
		},
		{
			title: '描述',
			dataIndex: 'desc',
			key: 'desc'
		},
		{
			title: '操作',
		   	slots: { customRender: 'action' },
			slot: 'action'
		}
	]
	export default defineComponent({
		setup() {
			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)

			const tableData = ref([])

			const fetchList = async () => {
				try {
					const { data } = await getDraftList()
					tableData.value = data
				} catch (e) {
					console.error(e)
				}
			}

			const addToTemplate = async (id) => {
				try {
					try {
						await addDraftToTemp({ draftId: id })
						fetchList()
						message.success('添加成功')
					} catch (e) {
						console.error(e);
					}
					
				} catch (e) {
					console.error(e)
				}
			}

			onMounted(() => {
				fetchList()
			})
			return {
				scroll,
				columns,
				tableData,
				addToTemplate
			}
		}
	})
